import { useNullableContext } from '~/common/contexts/nullableContext';
import { FeaturesContext } from '../../FeaturesContext';
import { FeaturesContextType } from '../../types/FeaturesContextType';

export const useFeatures = (): FeaturesContextType => {
  const featuresContext = useNullableContext(
    FeaturesContext,
    'useFeatures must be used within a FeaturesContext.Provider',
  );

  return featuresContext;
};
